module.exports = __webpack_public_path__ + "static/go-mobile@2x-5a4ade81f96747d5c62854340fbc9fb4.png";